export default __webpack_public_path__ + "static/media/match.f9065b4c.png";